
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {standardApi} from "@/api/standard";
    import SelectMechanism from "@/components/SelectMechanism.vue";

    @Component({
        components: {SelectMechanism}
    })
    export default class InstrumentList extends Vue {
        title = "";
        Dialog = true;
        listData = [] as any;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        propParams = {
            name: "",
            measuringStandardName: "",
            type: ""
        }
        showForm = false;
        listTotal = 0;

        /**
         * 控制展示参数
         * type  0普通 1社会  2单位最高
         * */
        @Prop() private propOption!: any;

        created() {
            this.setTitle();
            this.list();
        }

        setTitle(){
            if(this.propOption == "1"){
                this.title = "社会公用计量标准"
            }else if(this.propOption == "2"){
                this.title = "单位最高计量标准"
            }
            this.title += "-标准器与配套设备"
        }
        list() {
            if(this.propOption == "2"){
                this.listData = [];
                this.listTotal = 0;
                return;
            }
            const params = {
                ...this.propParams,
                ...this.listParam,
            }
            standardApi.pageMeasuringDevices(params).then((r: any) => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                }
            })
        }
        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.listParam.current = 1;
            this.list();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }
        clickRow(row:any){
            this.$confirm('确定要使用'+row.name+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit("activeData",row);
            }).catch(() => {
                console.log("取消")
            });
        }
        //改变制造单位
        changeManufactory(e: any){
            console.log(e)
        }
        closeDialog(){
            this.$emit("closeDialog");
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }
        reset() {
            this.propParams.name = '';//名称
            this.propParams.measuringStandardName = '';//
            this.propParams.type = '';//
            this.refresh();
        }
    }
